module.exports = __webpack_public_path__ + "static/media/five.2887f4c3.jpg";